class CollapsibleSection {
    constructor() {
        this.instances = document.querySelectorAll('.js-collapsible-section');
    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        self.enhanceAll(self);
    }

    enhance(instance, self) {
        let buttonText,
            buttonHtml,
            contents,
            heading,
            headingNodes,
            options,
            path,
            svg;

        if (
            ('DIV' !== instance.tagName)
            && ('SECTION' !== instance.tagName)
            && ('NAV' !== instance.tagName)
        ) {
            return;
        }

        if (!instance.id) return;

        if (!instance.hasAttribute('aria-labelledby')) return;

        if (!instance.querySelector('#' + instance.getAttribute('aria-labelledby'))) return;
        
        if (!self.helpers.headingTagNames.includes(instance.querySelector('#' + instance.getAttribute('aria-labelledby')).tagName))  return;
        
        heading = instance.querySelector('#' + instance.getAttribute('aria-labelledby'));

        if (
            (1 === heading.children.length)
            && ('A' === heading.children[0].tagName)
        ) {
            let a = heading.querySelector('a'),
                aNodes = a.childNodes;

            while (a.childNodes[0]) {
                heading.appendChild(a.removeChild(a.childNodes[0]));
            }

            heading.removeChild(a);
        }

        let button = self.helpers.createElementFromString(`
        <button
            type="button"
            aria-expanded="false"
            class="button button--toggle"
        >
            <span class="text"></span>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12 7"
                width="10"
                height="6"
                aria-hidden="true"
                class="icon"
            >
                <path
                    d="M10.8727 0.2925C10.4827 -0.0975 9.85274 -0.0975001 9.46274 0.2925L5.58274 4.1725L1.70274 0.2925C1.31274 -0.0975004 0.682741 -0.0975005 0.292741 0.2925C-0.0972596 0.6825 -0.0972596 1.3125 0.292741 1.7025L4.88274 6.2925C5.27274 6.6825 5.90274 6.6825 6.29274 6.2925L10.8827 1.7025C11.2627 1.3225 11.2627 0.6825 10.8727 0.2925Z"
                    fill="currentColor"
                    data-d="M10.8727 0.2925C10.4827 -0.0975 9.85274 -0.0975001 9.46274 0.2925L5.58274 4.1725L1.70274 0.2925C1.31274 -0.0975004 0.682741 -0.0975005 0.292741 0.2925C-0.0972596 0.6825 -0.0972596 1.3125 0.292741 1.7025L4.88274 6.2925C5.27274 6.6825 5.90274 6.6825 6.29274 6.2925L10.8827 1.7025C11.2627 1.3225 11.2627 0.6825 10.8727 0.2925Z"
                    data-d-alt="M10.8725 6.29246C10.4825 6.68246 9.8525 6.68246 9.4625 6.29246L5.5825 2.41246L1.7025 6.29246C1.3125 6.68246 0.682497 6.68246 0.292497 6.29246C-0.0975033 5.90246 -0.0975034 5.27246 0.292497 4.88246L4.8825 0.292461C5.2725 -0.0975388 5.9025 -0.0975388 6.2925 0.292461L10.8825 4.88246C11.2625 5.26246 11.2625 5.90246 10.8725 6.29246Z"
                >
            </svg>
        </button>
        `);

        buttonText = button.querySelector('.text');
        
        while (heading.childNodes[0]) {
            buttonText.appendChild(heading.removeChild(heading.childNodes[0]));
        }
                
        heading.appendChild(button);

        button = heading.querySelector('button');

        contents = instance.parentElement.querySelectorAll('#' + instance.id + ' > :not(#' + heading.id + ')');
        
        for (let element of contents) {
            element.classList.add('js-collapsible-section-contents');
            self.helpers.accessibleHide(element);
        }
        
        button.addEventListener('click', e => self.toggleContent(e, self));
        
        instance.dataset.js = 'on';

        if (instance.dataset.ariaExpanded === 'true') {
            instance.dataset.ariaExpanded = 'false';

            button.click();
        } else {
            instance.dataset.ariaExpanded = 'false';
        }
    }
            
    enhanceAll(self) {
        for (let instance of self.instances) {
            instance = self.enhance(instance, self);
        }
    }
    
    toggleContent(e, self) {
        if ('click' !== e.type) return;
        
        if ('BUTTON' !== e.currentTarget.tagName) return;
        
        if ('button' !== e.currentTarget.type) return;
        
        if (!e.currentTarget.hasAttribute('aria-expanded')) return;
        
        if ('' === e.currentTarget.getAttribute('aria-expanded')) return;
        
        if (
            ('false' !== e.currentTarget.getAttribute('aria-expanded'))
            && ('true' !== e.currentTarget.getAttribute('aria-expanded'))
            ) {
            return;
        }

        let button = e.currentTarget,
            instance = button.closest('.js-collapsible-section[data-js="on"]'),
            collapsibleSectionContents = instance.querySelectorAll('.js-collapsible-section-contents'),
            path = button.querySelector('svg.icon > path');

        if ('false' === button.getAttribute('aria-expanded')) {
            for (let element of collapsibleSectionContents) {
                self.helpers.accessibleShow(element);
            }

            button.setAttribute('aria-expanded', 'true');
            path.setAttribute('d', path.getAttribute('data-d-alt'));

            instance.dataset.ariaExpanded = 'true';
        } else {
            for (let element of collapsibleSectionContents) {
                self.helpers.accessibleHide(element);
            }

            button.setAttribute('aria-expanded', 'false');
            path.setAttribute('d', path.getAttribute('data-d'));
            instance.dataset.ariaExpanded = 'false';
        }
    }

    unenhance(instance, self) {
        if (!instance) return;
        if (!instance.classList.contains('js-collapsible-section')) return;
        if (!instance.hasAttribute('aria-labelledby')) return;
        if (!instance.getAttribute('aria-labelledby')) return;

        instance.classList.remove('js-collapsible-section');

        instance.removeAttribute('data-aria-expanded');
        instance.removeAttribute('data-js');

        let heading = instance.querySelector('#' + instance.getAttribute('aria-labelledby')),
            button = instance.querySelector('button.button--toggle'),
            icon = button.querySelector('.icon'),
            collapsibleSectionContents = instance.querySelectorAll('.js-collapsible-section-contents');

        icon.parentElement.removeChild(icon);

        while (button.childNodes[0]) {
            heading.appendChild(button.childNodes[0]);
        }

        heading.removeChild(button);

        for (let element of collapsibleSectionContents) {
            self.helpers.accessibleShow(element);

            element.style.removeProperty('--style');

            element.classList.remove('js-collapsible-section-contents');
        }
    }
}// end Class

// Singleton
export default CollapsibleSection;